import React from "react";
import Styles from "./terms.module.scss";
import { testIdProps } from "../../../../utils/testIdProps";

interface ITermsAndConditions {
  formik?: any;
}

const TermsAndConditions: React.FC<ITermsAndConditions> = ({ formik }) => {
  return (
    <>
      <div className="d-flex align-items-center gap-2 mt-4 mb-2">
        <input
          type="checkbox"
          {...testIdProps("terms-checkbox")}
          name="agreeToTerms"
          onChange={formik.handleChange}
          checked={formik.values.agreeToTerms}
          className={`${Styles.input}`}
        />
        <label
          className="form-check-label text-typo-titles-H2 text-sm"
          htmlFor="terms-checkbox"
        >
          I agree to the
          <a
            {...testIdProps("terms-and-conditions-link")}
            href="https://www.zoop.one/terms-and-conditions"
            className="text-dark fw-medium text-decoration-none text-10px"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Terms and Conditions{" "}
          </a>
          and
          <a
            {...testIdProps("privacy-policy-link")}
            href="https://www.zoop.one/privacy-policy"
            className="text-dark fw-medium text-decoration-none text-10px"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Privacy Policy
          </a>
        </label>
      </div>
      {formik.touched.agreeToTerms && formik.errors.agreeToTerms && (
        <div className="text-xs text-danger d-block">
          {formik.errors.agreeToTerms}
        </div>
      )}
    </>
  );
};

export default TermsAndConditions;
